// App
export const SWITCH_APP = 'SWITCH_APP';
export const LOADING_PROCCESS = 'LOADING_PROCCESS';
export const ERROR = 'ERROR';
export const DUPLICATE_MESSAGE = 'DUPLICATE_MESSAGE';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const SHOW_CONFIRM = 'SHOW_CONFIRM';
export const HIDE_CONFIRM = 'HIDE_CONFIRM';
export const CLEAR_COMPANY = 'CLEAR_COMPANY';
export const CLEAR_RESTAURANT = 'CLEAR_RESTAURANT';
export const CLEAR_LOYALTY_PROGRAM = 'CLEAR_LOYALTY_PROGRAM';
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const SET_EDITED_ENTITY = 'SET_EDITED_ENTITY';
export const UPDATE_ENTITY_FIELD = 'UPDATE_ENTITY_FIELD';
export const REST_COVER_IMAGE_UPLOADED = 'REST_COVER_IMAGE_UPLOADED';
export const LOGO_IMAGE_UPLOADED = 'LOGO_IMAGE_UPLOADED';
export const MENU_ITEM_IMAGE_UPLOADED = 'MENU_ITEM_IMAGE_UPLOADED';
export const SMART_PROMOTION_BANNER_UPLOADED = 'SMART_PROMOTION_BANNER_UPLOADED';
export const SMART_PROMOTION_BANNER_DELETED = 'SMART_PROMOTION_BANNER_DELETED';
export const NEW_PANEL_VERSION_DETECTED = 'NEW_PANEL_VERSION_DETECTED';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

// Auth
export const SETUP = 'SETUP';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const VERIFICATION_FAILED = 'VERIFICATION_FAILED';
export const GET_USER_SETTINGS = 'GET_USER_SETTINGS';
export const UPDATE_USER_SETTINGS = 'UPDATE_USER_SETTINGS';

// Meta
export const FETCH_META = 'FETCH_META';

// Locales
export const FETCH_LOCALES = 'FETCH_LOCALES';

// Tools
export const FETCH_COMMON_IMAGES = 'FETCH_COMMON_IMAGES';

// Restaurants
export const SET_CURRENT_RESTAURANT = 'SET_CURRENT_RESTAURANT';
export const FETCH_RESTAURANTS = 'FETCH_RESTAURANTS';
export const FETCH_ARCHIVED_RESTAURANTS = 'FETCH_ARCHIVED_RESTAURANTS';
export const FETCH_RESTAURANT = 'FETCH_RESTAURANT';
export const SAVE_RESTAURANT = 'SAVE_RESTAURANT';
export const DELETE_RESTAURANT = 'DELETE_RESTAURANT';
export const FETCH_RESTAURANT_SALES_DATA = 'FETCH_RESTAURANT_SALES_DATA';
export const FETCH_RESTAURANT_ACTIVITY_PERIODS = 'FETCH_RESTAURANT_ACTIVITY_PERIODS';
export const UPDATE_RESTAURANT_ACTIVITY_PERIODS = 'UPDATE_RESTAURANT_ACTIVITY_PERIODS';
export const UPDATE_RESTAURANT_DELIVERY_PERIODS = 'UPDATE_RESTAURANT_DELIVERY_PERIODS';
export const UPDATE_RESTAURANT_DELIVERY_AREAS = 'UPDATE_RESTAURANT_DELIVERY_AREAS';
export const FETCH_ACTIVE_ORDERS = 'FETCH_ACTIVE_ORDERS';
export const FETCH_ORDER = 'FETCH_ORDER';
export const SEND_TEST_ORDER = 'SEND_TEST_ORDER';
export const FETCH_ORDER_ITEMS = 'FETCH_ORDER_ITEMS';
export const CLEAR_NEW_ORDERS = 'CLEAR_NEW_ORDERS';
export const CLOSE_ORDER = 'CLOSE_ORDER';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const GENERATE_RECEIPT = 'GENERATE_RECEIPT';
export const CREDIT_PAYMENT = 'CREDIT_PAYMENT';
export const RESEND_ORDER = 'RESEND_ORDER';
export const FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS';
export const SAVE_SUBSCRIPTION = 'SAVE_SUBSCRIPTION';
export const DELETE_SUBSCRIPTION = 'DELETE_SUBSCRIPTION';
export const FETCH_RESTAURANT_MENU = 'FETCH_RESTAURANT_MENU';
export const FETCH_RESTAURANT_MENU_TRANSLATIONS = 'FETCH_RESTAURANT_MENU_TRANSLATIONS';
export const FETCH_RESTAURANT_MENU_UPSELLS = 'FETCH_RESTAURANT_MENU_UPSELLS';
export const SAVE_CATEGORY = 'SAVE_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const SAVE_ITEM = 'SAVE_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const SAVE_UPSELL = 'SAVE_UPSELL';
export const DELETE_UPSELL = 'DELETE_UPSELL';
export const UPLOAD_MENU_JSON = 'UPLOAD_MENU_JSON';
export const FETCH_RESTAURANT_GROUPS = 'FETCH_RESTAURANT_GROUPS';
export const ADD_MEMBER_TO_RESTAURANT_GROUP = 'ADD_MEMBER_TO_RESTAURANT_GROUP';
export const SAVE_GROUP = 'SAVE_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';
export const REMOVE_GROUP_MEMBER = 'REMOVE_GROUP_MEMBER';
export const FETCH_RESTAURANT_REWARDS = 'FETCH_RESTAURANT_REWARDS';
export const SAVE_REWARD = 'SAVE_REWARD';
export const SET_REWARD_FOR_DISTRIBUTE = 'SET_REWARD_FOR_DISTRIBUTE';
export const DISTRIBUTE_REWARD = 'DISTRIBUTE_REWARD';
export const DELETE_REWARD = 'DELETE_REWARD';
export const FETCH_GLOBAL_DISCOUNTS = 'FETCH_GLOBAL_DISCOUNTS';
export const SAVE_GLOBAL_DISCOUNT = 'SAVE_GLOBAL_DISCOUNT';
export const DELETE_GLOBAL_DISCOUNT = 'DELETE_GLOBAL_DISCOUNT';
export const FETCH_RESTAURANT_CONFIG = 'FETCH_RESTAURANT_CONFIG';
export const CREATE_POS_TERMINAL = 'CREATE_POS_TERMINAL';
export const TOGGLE_SOUND_NOTIFICATIONS = 'TOGGLE_SOUND_NOTIFICATIONS';

// Website
export const FETCH_WEBSITE = 'FETCH_WEBSITE';
export const SAVE_WEBSITE = 'SAVE_WEBSITE';

// Kiosks
export const FETCH_KIOSKS = 'FETCH_KIOSKS';
export const SAVE_KIOSK = 'SAVE_KIOSK';
export const DELETE_KIOSK = 'DELETE_KIOSK';

// Brands
export const FETCH_BRANDS = 'FETCH_BRANDS';
export const FETCH_FULL_BRAND = 'FETCH_FULL_BRAND';
export const UPLOAD_BRAND_ASSET = 'UPLOAD_BRAND_ASSET';
export const REMOVE_BRAND_ASSET = 'REMOVE_BRAND_ASSET';
export const SAVE_BRAND = 'SAVE_BRAND';
export const UPDATE_BRAND = 'UPDATE_BRAND';
export const UPDATE_BRAND_THEME = 'UPDATE_BRAND_THEME';

// Marketing Campaigns
export const FETCH_MARKETING_CAMPAIGNS = 'FETCH_MARKETING_CAMPAIGNS';
export const CREATE_MARKETING_CAMPAIGNS = 'CREATE_MARKETING_CAMPAIGNS';
export const UPDATE_MARKETING_CAMPAIGNS = 'UPDATE_MARKETING_CAMPAIGNS';
export const DELETE_MARKETING_CAMPAIGN = 'DELETE_MARKETING_CAMPAIGN';

// Delivery
export const SWITCH_DELIVERY_TAB = 'SWITCH_DELIVERY_TAB';

// Tags
export const FETCH_TAGS = 'FETCH_TAGS';
export const ADD_TAG = 'ADD_TAG';

// Companies
export const FETCH_COMPANIES = 'FETCH_COMPANIES';
export const SAVE_COMPANY = 'SAVE_COMPANY';
export const DELETE_COMPANY = 'DELETE_COMPANY';
export const ADD_WORKER_TO_COMPANY = 'ADD_WORKER_TO_COMPANY';
export const FETCH_WORKERS = 'FETCH_WORKERS';
export const LOCK_WORKER_BUDGET = 'LOCK_WORKER_BUDGET';
export const REMOVE_WORKER_FROM_COMPANY = 'REMOVE_WORKER_FROM_COMPANY';
export const FETCH_WORKER_PERMISSIONS = 'FETCH_WORKER_PERMISSIONS';
export const GRANT_PAYMENT_PERMISSION = 'GRANT_PAYMENT_PERMISSION';
export const REVOKE_PAYMENT_PERMISSION = 'REVOKE_PAYMENT_PERMISSION';
export const FETCH_COMPANY_BUDGET_GROUPS = 'FETCH_COMPANY_BUDGET_GROUPS';
export const SAVE_BUDGET_GROUP = 'SAVE_BUDGET_GROUP';
export const DELETE_BUDGET_GROUP = 'DELETE_BUDGET_GROUP';
export const START_BUDGET_LOAD = 'START_BUDGET_LOAD';
export const CANCEL_BUDGET_LOAD = 'CANCEL_BUDGET_LOAD';
export const CHANGE_BUDGET_LOAD_DATE = 'CHANGE_BUDGET_LOAD_DATE';
export const LOAD_BUDGET = 'LOAD_BUDGET';
export const FETCH_COMPANY_PAYMENT_OPTIONS = 'FETCH_COMPANY_PAYMENT_OPTIONS';
export const FETCH_MONTHLY_BUDGET_BREAKDOWN = 'FETCH_MONTHLY_BUDGET_BREAKDOWN';
export const FETCH_COMPANY_ORDERS = 'FETCH_COMPANY_ORDERS';
export const NOTIFY_ON_ORDER_ARRIVAL = 'NOTIFY_ON_ORDER_ARRIVAL';

/* Loyalty Programs */
export const FETCH_LOYALTY_PROGRAMS = 'FETCH_LOYALTY_PROGRAMS';
export const SAVE_LOYALTY_PROGRAM = 'SAVE_LOYALTY_PROGRAM';
export const DELETE_LOYALTY_PROGRAM = 'DELETE_LOYALTY_PROGRAM';
// Restaurants
export const FETCH_LOYALTY_PROGRAM_RESTAURANTS = 'FETCH_LOYALTY_PROGRAM_RESTAURANTS';
export const ADD_RESTAURANT_TO_LOYALTY_PROGRAM = 'ADD_RESTAURANT_TO_LOYALTY_PROGRAM';
export const REMOVE_RESTAURANT_FROM_LOYALTY_PROGRAM = 'REMOVE_RESTAURANT_FROM_LOYALTY_PROGRAM';
// Members
export const FETCH_LOYALTY_PROGRAM_MEMBERS = 'FETCH_LOYALTY_PROGRAM_MEMBERS';
export const ADD_MEMBER_TO_LOYALTY_PROGRAM = 'ADD_MEMBER_TO_LOYALTY_PROGRAM';
export const REMOVE_MEMBER_FROM_LOYALTY_PROGRAM = 'REMOVE_MEMBER_FROM_LOYALTY_PROGRAM';
// Campaigns
export const FETCH_LOYALTY_PROGRAM_CAMPAIGNS = 'FETCH_LOYALTY_PROGRAM_CAMPAIGNS';
export const SAVE_CAMPAIGN = 'SAVE_CAMPAIGN';
export const CLOSE_CAMPAIGN = 'CLOSE_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
// Benefits
export const FETCH_LOYALTY_PROGRAM_BENEFITS = 'FETCH_LOYALTY_PROGRAM_BENEFITS';
export const SAVE_BENEFIT = 'SAVE_BENEFIT';
export const DELETE_BENEFIT = 'DELETE_BENEFIT';
// Issues
export const ISSUE_BENEFIT = 'ISSUE_BENEFIT';
export const CLOSE_ISSUED_BENEFIT = 'CLOSE_ISSUED_BENEFIT';
export const UPDATE_ISSUED_BENEFIT = 'UPDATE_ISSUED_BENEFIT';

// Others
export const FETCH_CHAINS = 'FETCH_CHAINS';
export const FETCH_CHAIN = 'FETCH_CHAIN';
export const SET_CURRENT_CHAIN_ID = 'SET_CURRENT_CHAIN_ID';
export const SAVE_CHAIN = 'SAVE_CHAIN';
export const DELETE_CHAIN = 'DELETE_CHAIN';
export const FETCH_DASHBOARD_USER = 'FETCH_DASHBOARD_USER';
export const SAVE_DASHBOARD_USER = 'SAVE_DASHBOARD_USER';
export const DELETE_DASHBOARD_USER = 'DELETE_DASHBOARD_USER';

// Reports
export const FETCH_PAYMENTS_REPORT = 'FETCH_PAYMENTS_REPORT';
export const FETCH_BUDGET_REPORT = 'FETCH_BUDGET_REPORT';
export const FETCH_CAMPAIGN_REPORT = 'FETCH_CAMPAIGN_REPORT';
export const FETCH_CAMPAIGN_USAGES_REPORT = 'FETCH_CAMPAIGN_USAGES_REPORT';
export const FETCH_MEMBER_PURCHASE_HISTORY = 'FETCH_MEMBER_PURCHASE_HISTORY';
export const INVOICE_SENT = 'INVOICE_SENT';

// Menus 
export const CREATE_MENU = 'CREATE_MENU';
export const FETCH_MENU = 'FETCH_MENU';
export const PREPARE_MENU = 'PREPARE_MENU';
export const SAVE_MENU_CATEGORY = 'SAVE_MENU_CATEGORY';
export const DELETE_MENU_CATEGORY = 'DELETE_MENU_CATEGORY';
export const DELETE_MENU_OVERRIDE = 'DELETE_MENU_OVERRIDE';
export const SAVE_MENU_ITEM = 'SAVE_MENU_ITEM';
export const DELETE_MENU_ITEM = 'DELETE_MENU_ITEM';
export const UPDATE_MENU_EDIT_INFO = 'UPDATE_MENU_EDIT_INFO';
export const UPDATE_SMART_PROMOTION = 'UPDATE_SMART_PROMOTION';
export const CREATE_SMART_PROMOTION = 'CREATE_SMART_PROMOTION';
export const FETCH_SMART_PROMOTIONS = 'FETCH_SMART_PROMOTIONS';
